import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

const PortfolioDetails = () => {
    const [active, setActive] = useState("All");
    const [categories, setCategories] = useState([]);
    const [projects, setProjects] = useState([]);

    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    // 🔥 Fetch Categories
    useEffect(() => {
        fetch("https://codebuddys.in/wp-json/wp/v2/project-category")
            .then((res) => res.json())
            .then((data) => setCategories(data));
    }, []);

    // 🔥 Fetch Projects
    useEffect(() => {
        fetch(
            "https://codebuddys.in/wp-json/wp/v2/projects?_embed&per_page=100"
        )
            .then((res) => res.json())
            .then((data) => setProjects(data));
    }, []);

    // 🔥 Filter Logic
    const filtered =
        active === "All"
            ? projects
            : projects.filter((project) =>
                project._embedded["wp:term"]?.[0]?.some(
                    (cat) => cat.id === active.id
                )
            );

    // 🔥 Prepare images for slider
    const slides = filtered.map((item) => ({
        src: item._embedded["wp:featuredmedia"]?.[0]?.source_url,
    }));

    return (
        <div>
            <section className="portfolio-full">
                <h2 className="title" style={{ margin: "0" }}>Work Showcase</h2>
                <p style={{ textAlign: "center", marginBottom:"50px" }}>
                    Delivering impactful digital experiences through design and development.</p>
                <div className="portfolio-wrapper">
                    {/* LEFT FILTER */}
                    <div className="left-filter">
                        <h3
                            className={active === "All" ? "active" : ""}
                            onClick={() => setActive("All")}
                        >
                            All
                        </h3>

                        {categories.map((cat) => (
                            <h3
                                key={cat.id}
                                className={active?.id === cat.id ? "active" : ""}
                                onClick={() => setActive(cat)}
                            >
                                {cat.name}
                            </h3>
                        ))}
                    </div>

                    {/* GRID */}
                    <div className="right-grid masonry-grid">
                        {filtered.map((item, i) => {
                            const img =
                                item._embedded["wp:featuredmedia"]?.[0]?.source_url;

                            const allTerms = item._embedded["wp:term"] || [];
                            const itemCategories = allTerms.flat();

                            return (
                                <div
                                    className="card"
                                    key={item.id}
                                    onClick={() => {
                                        setIndex(i); // 🔥 open at clicked image
                                        setOpen(true);
                                    }}
                                >
                                    <div className="badge-group">
                                        {itemCategories.map((cat) => (
                                            <span key={cat.id} className="category-badge">
                                                {cat.name}
                                            </span>
                                        ))}
                                    </div>

                                    <img src={img} alt="" />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* 🔥 LIGHTBOX SLIDER */}
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={index}
                slides={slides}
                plugins={[Zoom]} // 🔥 zoom enable
            />

        </div>
    );
};

export default PortfolioDetails;